
export default {
  rankList: {
    url: '/keywordRank/rankList',
    method: 'post',
    desc: '关键词排名列表'
  },
  rankListDetails: {
    url: '/keywordRank/rankList/details',
    method: 'post',
    desc: '关键词排名列表展开行'
  },
  getParentAsin: {
    url: '/keywordRank/rankList/getParentAsin',
    method: 'post',
    desc: '校验asin'
  },
  addMonitor: {
    url: '/keywordRank/rankList/addMonitor',
    method: 'post',
    desc: '添加商品监控'
  },
  otherAsin: {
    url: '/keywordRank/rankList/addMonitor/otherAsin',
    method: 'post',
    desc: '添加竞品'
  },
  parentAsinList: {
    url: '/keywordRank/rankList/parentAsinList',
    method: 'post',
    desc: '查看全部变体'
  },
  updateAsinList: {
    url: '/keywordRank/rankList/updateAsinList',
    method: 'post',
    desc: '更新变体'
  },
  addMonitorText: {
    url: '/keywordRank/rankList/addMonitorText',
    method: 'post',
    desc: '添加关键词'
  },
  deleteMonitor: {
    url: '/keywordRank/rankList/deleteMonitor',
    method: 'post',
    desc: '删除监控'
  },
  deleteMonitorText: {
    url: '/keywordRank/rankList/deleteMonitorText',
    method: 'post',
    desc: '展开行-删除关键词'
  },
  keywordNum: {
    url: '/keywordRank/getAccess/keywordNum',
    method: 'post',
    desc: '检验添加关键词额度'
  },
  chart: {
    url: '/keywordRank/rankList/details/chart',
    method: 'post',
    desc: '查看趋势图'
  },
}
